
import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/sections/HeroSection';
import WhatWeDoSection from '../components/sections/WhatWeDoSection';
import WhatWeOfferSection from '../components/sections/WhatWeOfferSection';
import AboutUsSection from '../components/sections/AboutUsSection';
import ContactCTASection from '../components/sections/ContactCTASection';
import AcquisitionFocusSection from '../components/sections/AcquisitionFocusSection';
import { useLanguage } from '@/contexts/LanguageContext';

const Index: React.FC = () => {
  const { language } = useLanguage();
  
  return (
    <div className="min-h-screen bg-noa-antiflash-white">
      <Navbar />
      
      <main>
        <HeroSection />
        <WhatWeDoSection />
        <AcquisitionFocusSection />
        <WhatWeOfferSection />
        <AboutUsSection />
        <ContactCTASection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Index;
